import React, { useEffect } from "react";
import { useTheme } from "../theme";

const STYLE_ID = "biostream-spinner-css";

function ensureStyles() {
  if (document.getElementById(STYLE_ID)) return;
  const el = document.createElement("style");
  el.id = STYLE_ID;
  el.textContent = `
@keyframes bs-piston {
  0%, 80% { transform: rotate(-45deg) translateX(0%);    opacity: 1; }
  85%     { transform: rotate(-45deg) translateX(350%);   opacity: 0; }
  86%     { transform: rotate(-45deg) translateX(-70vw);  opacity: 0; }
  93%     {                                               opacity: 1; }
  100%    { transform: rotate(-45deg) translateX(0%);    opacity: 1; }
}
@keyframes bs-joint-spin {
  0%, 15%   { transform: rotateZ(0deg); }
  40%, 100% { transform: rotateZ(360deg); }
}
@keyframes bs-gear-tumble {
  0%, 40%   { transform: rotate3d(1, -1, 0, 0deg); }
  80%, 100% { transform: rotate3d(1, -1, 0, 360deg); }
}
`;
  document.head.appendChild(el);
}

/**
 * Three-stage mechanical animation:
 *  1. Piston (slash) slides in diagonally           0% → 15%
 *  2. Unit spins together (joint spin)             15% → 40%
 *  3. O ring tumbles over diagonal axis (gear)     40% → 80%
 *  4. Piston slides back out                       85% → 100%
 */
export function BioSpinner({ size = 80, color }: { size?: number; color?: string }) {
  const { theme } = useTheme();
  const resolvedColor = color ?? (theme === "dark" ? "#ffffff" : "#1a1a1a");

  useEffect(() => { ensureStyles(); }, []);

  const circleSize = Math.round(size * 0.5);
  const border     = Math.round(circleSize * 0.1);
  const pistonW    = Math.round(circleSize * 0.8);
  const pistonH    = border;
  const easing     = "cubic-bezier(0.4, 0, 0.2, 1)";

  return (
    <div style={{ position: "relative", width: size, height: size, perspective: `${size * 6}px`, display: "flex", alignItems: "center", justifyContent: "center" }}>
      {/* machine-unit: joint spin wrapper */}
      <div style={{
        position: "relative",
        width: size,
        height: size,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transformStyle: "preserve-3d",
        animation: `bs-joint-spin 6s infinite ${easing}`,
      }}>
        {/* circle-gear: the O ring */}
        <div style={{
          width: circleSize,
          height: circleSize,
          border: `${border}px solid ${resolvedColor}`,
          borderRadius: "50%",
          boxSizing: "border-box",
          position: "absolute",
          animation: `bs-gear-tumble 6s infinite ${easing}`,
        }} />
        {/* driving-piston: the diagonal slash */}
        <div style={{
          position: "absolute",
          width: pistonW,
          height: pistonH,
          background: resolvedColor,
          borderRadius: pistonH / 2,
          animation: `bs-piston 6s infinite ${easing}`,
        }} />
      </div>
    </div>
  );
}
